import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'module-tsl-ui-modal';
import PaymentSuccess from './components/PaymentSuccess';

var PaymentSuccessModal = function PaymentSuccessModal(_ref) {
  var show = _ref.show,
      onHideModal = _ref.onHideModal,
      isBundleSale = _ref.isBundleSale,
      bundledResourcesIds = _ref.bundledResourcesIds,
      loadingRelated = _ref.loadingRelated,
      loadRelatedResources = _ref.loadRelatedResources,
      resourceAuthorUsername = _ref.resourceAuthorUsername,
      relatedResourcesTimeout = _ref.relatedResourcesTimeout,
      relatedResourceFailed = _ref.relatedResourceFailed,
      relatedResources = _ref.relatedResources,
      title = _ref.title,
      fileAttachmentCount = _ref.fileAttachmentCount,
      singleAttachment = _ref.singleAttachment,
      recommendedResources = _ref.recommendedResources,
      recommendedResourcesTimeout = _ref.recommendedResourcesTimeout,
      hasDownloadBundle = _ref.hasDownloadBundle,
      resourceIds = _ref.resourceIds,
      userName = _ref.userName;
  return /*#__PURE__*/React.createElement("div", {
    className: "payment"
  }, /*#__PURE__*/React.createElement(Modal, {
    showModal: show,
    id: "PaymentSuccessModal",
    size: "lg",
    onHideModal: onHideModal
  }, /*#__PURE__*/React.createElement(PaymentSuccess, {
    bundledResourcesIds: bundledResourcesIds,
    hasDownloadBundle: hasDownloadBundle,
    isBundleSale: isBundleSale,
    loadingRelated: loadingRelated,
    loadRelatedResources: loadRelatedResources,
    resourceAuthorUsername: resourceAuthorUsername,
    relatedResourcesTimeout: relatedResourcesTimeout,
    relatedResourceFailed: relatedResourceFailed,
    relatedResources: relatedResources,
    resourceIds: resourceIds,
    title: title,
    fileAttachmentCount: fileAttachmentCount,
    singleAttachment: singleAttachment,
    recommendedResources: recommendedResources,
    recommendedResourcesTimeout: recommendedResourcesTimeout,
    userName: userName
  })));
};

PaymentSuccessModal.displayName = "PaymentSuccessModal";
PaymentSuccessModal.propTypes = {
  bundledResourcesIds: PropTypes.array,
  onHideModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  hasDownloadBundle: PropTypes.bool.isRequired,
  isBundleSale: PropTypes.bool,
  loadingRelated: PropTypes.bool.isRequired,
  loadRelatedResources: PropTypes.func.isRequired,
  relatedResourcesTimeout: PropTypes.object,
  relatedResourceFailed: PropTypes.bool.isRequired,
  relatedResources: PropTypes.arrayOf(PropTypes.object).isRequired,
  resourceIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  title: PropTypes.string.isRequired,
  fileAttachmentCount: PropTypes.number.isRequired,
  singleAttachment: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  resourceAuthorUsername: PropTypes.string.isRequired,
  recommendedResources: PropTypes.arrayOf(PropTypes.object).isRequired,
  recommendedResourcesTimeout: PropTypes.object.isRequired,
  userName: PropTypes.string.isRequired
};
PaymentSuccessModal.defaultProps = {
  isBundleSale: false,
  bundledResourcesIds: []
};
export default PaymentSuccessModal;